import { z } from 'zod'
import { useZodForm } from '@minetrace/ui/forms'

// Email and phone are now required — every user must be reachable.
// Document type and identity doc were merged from the old Step0 — having a
// dedicated step just for two fields was overkill, and isolating the doc on
// its own step also let the browser autofill it with the username on edit.
// DNI 8-digit shape is enforced in the parent submit handler so the schema
// stays object-shaped (cleaner ref typing for the form wrapper).
export const step1DataSchema = z.object({
  documentType: z.number().int().min(1).max(3),
  identityDoc: z.string().min(1, 'personas.nuevo.zod.docRequired'),
  names: z.string().min(2, 'personas.nuevo.zod.minTwo'),
  paternalSurname: z.string().min(2, 'personas.nuevo.zod.minTwo'),
  maternalSurname: z.string().optional(),
  gender: z.number().optional(),
  email: z.string().min(1, 'personas.nuevo.zod.emailRequired').email('personas.nuevo.zod.emailInvalid'),
  phoneMobile: z.string().min(6, 'personas.nuevo.zod.phoneRequired'),
  address: z.string().optional(),
})

export type Step1DataFormValues = z.infer<typeof step1DataSchema>

const defaultValues: Step1DataFormValues = {
  documentType: 1,
  identityDoc: '',
  names: '',
  paternalSurname: '',
  maternalSurname: '',
  gender: undefined,
  email: '',
  phoneMobile: '',
  address: '',
}

export const useStep1DataForm = (props?: { defaultValues?: Step1DataFormValues }) =>
  useZodForm<Step1DataFormValues>({
    validationSchema: step1DataSchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
